<template>
	<v-container>
		<v-row  
			align 	= "center"
          	justify = "center">
			<v-col 
				xl 		= "4" 
				lg 		= "4" 
				sm 		= "8" 
				md 		= "5" 
				cols 	= "12"
			>
				<v-card 
					outlined
				>
					<v-card-title 
						class  = "justify-center body-2 success pa-1" 
						v-text = "$ml.get('recover_psw')"
					></v-card-title>
				<v-divider></v-divider>
				<v-form 
					name 			= "form" 
					@submit.prevent = "handle_recover" 
				>
					<v-card-text
						class = "pa-2"
					>
						<!-- <v-text-field v-model="user.username" :label="$ml.get('username')" prepend-icon="mdi-account" disabled
						></v-text-field> -->
						<v-text-field
							dense
							outlined
							hide-details 
							v-model 		= "password" 
							:label 		 	= "$ml.get('password')" 
							prepend-icon 	= "mdi-lock" 
							type 			= "password"
						></v-text-field>						
						<v-text-field 
							dense
							outlined
							hide-details
							v-model 		= "password1" 
							:label 			= "$ml.get('confirm_psw')" 
							prepend-icon 	= "mdi-lock"
							type 			= "password"
							class 			= "mt-1"
						></v-text-field>
					<div 
						v-show 	= "message" 
						:class 	= "color_text" 
						role 	= "alert"
					>
						{{message}}
					</div> <!-- alert alert-danger  -->
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
		                <v-spacer></v-spacer>
		                <v-btn 
		                	x-small
		                	color 		= "#2c5675" 
		                	@click 		= "dialog = true" 
		                	v-text 		= "$ml.get('confirm')" 
		                	v-show 		= "!loading" 
		                	:disabled 	= "!disabled"
		                ></v-btn>
		                
		                <v-progress-circular
		                	indeterminate
		                	color  = "primary"
		                	v-show = "loading">                
		                </v-progress-circular>
		              </v-card-actions>
				</v-form>
				</v-card>
			</v-col>
		</v-row>

		<v-dialog 
			v-model = "dialog" 
			width 	= "300"
		>
			<v-card 
				outlined 
				color = "secondary"
			>
				<v-card-title 
					v-text 	= "$ml.get('confirm')" 
					class 	= "justify-center pa-1 body-1 success"
				></v-card-title>
				<v-divider></v-divider>
				<v-card-text>
						<p 
							class = "pt-1 mb-1 pb-0"
						>
							{{ $ml.get('ms_c1') }}
						</p>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn 
						small 
						color 	= "primary" 
						@click 	= "handle_recover" 
						v-text 	= "$ml.get('confirm')" 
					></v-btn>
					<v-btn 
						small 
						color  	= "error" 
						@click 	= "dialog = false" 
						v-text 	= "$ml.get('close')"
						class 	= "mx-2"
					></v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		
	</v-container>
</template>
<script>
import User from '@/models/user';
import axios from 'axios';
	export default{
		name: 'recover_psw',
		
		data: () => ({
			// user: new User('','',''),
			password 	 : '',
			password1 	 : '',
			message 	 : '',
			color_text 	 : '',
			info 		 : '',
			snackbar 	 : false,
			color 		 : '',
			loading 	 : false,
			dialog 		 : false,
			reset_tokken : '',
			disabled 	 : false,
		}),
		watch:{
			password1(v){
				if (this.password !== v) {
					this.message 	= this.$ml.get('no_match')
					this.disabled  	= false;
					this.color_text = 'red--text';
				}else{
					this.message 	= this.$ml.get('match')
					this.disabled 	= true;
					this.color_text = 'success--text';
				}
			},
		},
		created(){			
			this.reset_tokken = this.$route.params.id
		},
		methods:{
			handle_recover(){
				this.dialog 	= false;
				this.loading 	= true; 
				const api 		= this.$URL + '/api/v1/auth/new-password ';
		// 		this.$store.dispatch('auth/recover_psw', this.user).then(
				axios.post(api, {
					resettoken  : this.reset_tokken,
					newpassword : this.password
				})
				.then(reponse => {
					this.$EventBus.$emit("notifications_modal",{
						typed : "saved"
					});
					this.loading = false;
					this.$router.push('/');
				}).catch( error =>{
					this.$EventBus.$emit("notifications_modal",{
						typed 	: "error",
						message : error, 
					});
					this.loading = false;
				});
			}
		},
	}
</script>